import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const EMOJI = {
  "All": "🔥",
  "Modest Fashion": "🧕",
  "Beauty & Fragrance": "💄",
  "Islamic Products": "☪️",
  "Fundraising": "🤲",
  "Jewelry & Accessories": "💎",
  "Halal Food": "🍔",
  "Halal Cooking": "🍳",
  "Home & Kitchen": "🏠",
  "Kids & Family": "🧸",
  "Electronics": "📱",
};

export function CategoryChips({ categories, selected, onSelect }) {
  const ref = useRef(null);
  const onWheel = (e) => {
    if (ref.current && e.deltaY !== 0) ref.current.scrollLeft += e.deltaY;
  };
  const scrollBy = (dir) => ref.current?.scrollBy({ left: dir * 280, behavior: "smooth" });

  return (
    <div className="chip-scroller">
      <button className="chip-arrow left" onClick={() => scrollBy(-1)} data-testid="chips-scroll-left" aria-label="Scroll categories left">
        <ChevronLeft size={18} />
      </button>
      <div className="ss-chips" ref={ref} onWheel={onWheel} data-testid="category-chips">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`ss-chip ${selected === cat ? "active" : ""}`}
            onClick={() => onSelect(cat)}
            data-testid={`chip-${cat.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <span style={{ marginRight: 6 }}>{EMOJI[cat] || ""}</span>{cat}
          </button>
        ))}
      </div>
      <button className="chip-arrow right" onClick={() => scrollBy(1)} data-testid="chips-scroll-right" aria-label="Scroll categories right">
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
